import SelectInputPlaceholder from '@/components/Select/InputPlaceholder';
import { FormHelperText, MenuItem, Select } from '@mui/material';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import PlaceholderCompanyIcon from '../../Icons/PlaceholderCompanyIcon';

const CompanySelect = forwardRef(({ placeholder, renderIcon, menuPlaceholder, options, ...props }, ref) => {
  const { value: propValue, helperText, ...selectProps } = props;
  const value = Array.isArray(propValue) ? propValue[0] : propValue;
  const selectedValue = options?.find(option => option.value === value?.value) || '';

  return (
    <>
      <Select
        {...selectProps}
        ref={ref}
        value={selectedValue}
        displayEmpty
        renderValue={selectValue =>
          !selectValue ? (
            <SelectInputPlaceholder>{placeholder}</SelectInputPlaceholder>
          ) : (
            <CompanyOptionRenderer renderIcon={renderIcon} option={selectValue} />
          )
        }
        fullWidth
      >
        {options.length ? (
          options.map((option, i) => (
            <MenuItem key={i} value={option}>
              <CompanyOptionRenderer option={option} renderIcon={renderIcon} />
            </MenuItem>
          ))
        ) : (
          <MenuItem value='' disabled>
            {menuPlaceholder}
          </MenuItem>
        )}
      </Select>
      <FormHelperText error={props.error}>{helperText}</FormHelperText>
    </>
  );
});

CompanySelect.propTypes = {
  id: PropTypes.string,
  labelId: PropTypes.string,
  renderIcon: PropTypes.bool,
  placeholder: PropTypes.string,
  menuPlaceholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  options: PropTypes.array,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.string,
};

CompanySelect.defaultProps = {
  value: '',
  options: [],
  menuPlaceholder: 'Please select a client first',
  renderIcon: true,
};

const CompanyOptionRenderer = ({ option, renderIcon }) => {
  return (
    <div className='flex items-center'>
      {renderIcon ? <span className='mr-[12px] flex-0'>{option.icon || <PlaceholderCompanyIcon />}</span> : null}
      <div>
        <div>{option.label}</div>
        <div className='text-[#84818A] text-[12px]'>{option.description}</div>
      </div>
    </div>
  );
};

CompanyOptionRenderer.propTypes = {
  option: PropTypes.object,
  renderIcon: PropTypes.bool,
};

export default CompanySelect;
